module.exports = __webpack_public_path__ + "img/online.2c627e06.svg";